import { render, staticRenderFns } from "./ArticleInfoLead.vue?vue&type=template&id=4763637a&functional=true&"
import script from "./ArticleInfoLead.vue?vue&type=script&lang=ts&"
export * from "./ArticleInfoLead.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports